// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.bg-percentage-green {
  background-color: #15b422;
}

.bg-percentage-light-green {
  background-color: #a3d000;
}

.bg-percentage-yellow {
  background-color: #fcb000;
}

.bg-percentage-red {
  background-color: #ff0000;
}

.progress-bar {
  height: 10px;
  border-radius: 7px;
}

.progress-bar-border {
  border-radius: 12px;
  border: 2px solid #aab2c0;
}

.title {
  min-width: 130px;
}

.coloured-dot,
.status-coloured-dot {
  height: 10px;
  width: 10px;
  margin-top: 2px;
  min-width: 10px;
}

::ng-deep .ng-select .ng-select-container {
  border: 1px solid lightgrey;
}

.project-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 2px;
}
.project-stats .stat {
  background-color: #414448;
  overflow: hidden;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.project-stats .stat.left {
  border-radius: 0.5rem 0 0 0.5rem;
}
.project-stats .stat.right {
  border-radius: 0 0.5rem 0.5rem 0;
}

.comment-container .comment-detail {
  overflow-y: scroll;
  background-color: white;
  border: 1px solid rgba(211, 211, 211, 0.75);
  border-radius: 0.5rem;
  padding: 1rem 1rem 0 1rem;
  width: 100%;
  height: 100%;
  max-height: 400px;
  min-height: 200px;
}

.comment {
  padding: 1rem;
}
.comment p {
  padding-bottom: 0;
  margin-bottom: 0;
}

.comment:hover {
  cursor: pointer;
  background-color: rgba(211, 211, 211, 0.3);
  border-radius: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/pages/project/project-search/project-card/project-card.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC5DA;EACC,yBD4DkB;AC1DnB;;AAAA;EACC,yBD0DwB;ACvDzB;;AADA;EACC,yBDwDmB;ACpDpB;;AAFA;EACC,yBDsDgB;ACjDjB;;AAHA;EACC,YAAA;EACA,kBAAA;AAMD;;AAJA;EACC,mBAAA;EACA,yBAAA;AAOD;;AALA;EACC,gBAAA;AAQD;;AALA;;EAEC,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAQD;;AALA;EACC,2BAAA;AAQD;;AALA;EACC,aAAA;EACA,gDAAA;EACA,eAAA;AAQD;AANC;EACC,yBDvBa;ECwBb,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAQF;AANE;EACC,gCAAA;AAQH;AALE;EACC,gCAAA;AAOH;;AAFA;EACC,kBAAA;EACA,uBAAA;EACA,2CAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAKD;;AAFA;EACC,aAAA;AAKD;AAHC;EACC,iBAAA;EACA,gBAAA;AAKF;;AADA;EACC,eAAA;EACA,0CAAA;EACA,qBAAA;AAID","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n.bg-percentage-green {\n\tbackground-color: $percentage-green;\n}\n.bg-percentage-light-green {\n\tbackground-color: $percentage-light-green;\n}\n.bg-percentage-yellow {\n\tbackground-color: $percentage-yellow;\n}\n.bg-percentage-red {\n\tbackground-color: $percentage-red;\n}\n.progress-bar {\n\theight: 10px;\n\tborder-radius: 7px;\n}\n.progress-bar-border {\n\tborder-radius: 12px;\n\tborder: 2px solid $placeholder;\n}\n.title {\n\tmin-width: 130px;\n}\n\n.coloured-dot,\n.status-coloured-dot {\n\theight: 10px;\n\twidth: 10px;\n\tmargin-top: 2px;\n\tmin-width: 10px;\n}\n\n::ng-deep .ng-select .ng-select-container {\n\tborder: 1px solid lightgrey;\n}\n\n.project-stats {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, minmax(0, 1fr));\n\tcolumn-gap: 2px;\n\n\t.stat {\n\t\tbackground-color: $kaliber-dark;\n\t\toverflow: hidden;\n\t\tpadding: 0.5rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\t&.left {\n\t\t\tborder-radius: 0.5rem 0 0 0.5rem;\n\t\t}\n\n\t\t&.right {\n\t\t\tborder-radius: 0 0.5rem 0.5rem 0;\n\t\t}\n\t}\n}\n\n.comment-container .comment-detail {\n\toverflow-y: scroll;\n\tbackground-color: white;\n\tborder: 1px solid rgba(lightgrey, 0.75);\n\tborder-radius: 0.5rem;\n\tpadding: 1rem 1rem 0 1rem;\n\twidth: 100%;\n\theight: 100%;\n\tmax-height: 400px;\n\tmin-height: 200px;\n}\n\n.comment {\n\tpadding: 1rem;\n\n\tp {\n\t\tpadding-bottom: 0;\n\t\tmargin-bottom: 0;\n\t}\n}\n\n.comment:hover {\n\tcursor: pointer;\n\tbackground-color: rgba(lightgray, 0.3);\n\tborder-radius: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
